import { ChangeDetectorRef, ElementRef, EventEmitter } from '@angular/core';
import { ReflectionHelper } from '../../common/reflection-helper';
var GridCheckboxComponent = /** @class */ (function () {
    function GridCheckboxComponent(elementRef, changeDetectorRef) {
        this.tooltip = '';
        this.helpTooltip = '';
        this.isOpenLink = true;
        this.helpIcon = 'Help';
        this.selfService = '';
        this.isLink = false;
        this.isGrid = true;
        this.editMode = true;
        this.valueChange = new EventEmitter();
    }
    Object.defineProperty(GridCheckboxComponent.prototype, "labelClass", {
        get: function () {
            return this.customClass + ' ' + (this.isGrid ? 'checkBox-label-center' : '');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridCheckboxComponent.prototype, "isDisabled", {
        get: function () {
            return this.disable ? this.disable : !this.editMode;
        },
        enumerable: true,
        configurable: true
    });
    GridCheckboxComponent.prototype.valid = function () {
        return true;
    };
    GridCheckboxComponent.prototype.convertValue = function (value) {
        if (value && ReflectionHelper.isString(value)) {
            return value.toLowerCase() === 'true';
        }
        else {
            return value;
        }
    };
    GridCheckboxComponent.prototype.onChange = function (value) {
        this.valueChange.emit(value);
    };
    return GridCheckboxComponent;
}());
export { GridCheckboxComponent };
